import { createFileRoute } from "@tanstack/react-router";
import { ExFactoryPricesPage } from "@/features/contracts/exfactory-prices-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/cenniki-exfactory/")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.kontrakty.nowy", location.pathname);
	},
	component: ExFactoryPricesPage,
});
